import BaseAPI from "../api";

const path: string = "collaboration-network";

export class CollaborationNetworkApi extends BaseAPI {
  static getAllCollaborationNetwork(query?: any): Promise<any> {
    return this.api.get(`${path}`, {
      params: { ...query },
    });
  }

  static createCollaborationNetwork(body: any): Promise<any> {
    return this.api.post(`${path}`, body);
  }

  static getCollaborationNetworkById(id: number): Promise<any> {
    return this.api.get(`${path}/${id}`);
  }

  static updateCollaborationNetwork(id: number, body: any): Promise<any> {
    return this.api.patch(`${path}/${id}`, body);
  }

  static deleteCollaborationNetwork(id: number): Promise<any> {
    return this.api.delete(`${path}/${id}`);
  }
}